import React, { Component } from "react";
import '../Styles/Experience.css';

export default class Experience extends Component {
  render() {
    return (
      <section
        className="experience"
        id="exp"
      >
        <div className="experience-container" 
          data-aos="fade-right" 
          data-aos-duration="1000"
        >
          <h1 
            className="title-exp"
          >
            Experiência Profissional
          </h1>
        <div className="experience-description">
          <h2>Técnico de TI</h2>
            <span>Empresa: Ideal Informática e Celulares</span>
            <p>Período: Julho de 2019 a Março de 2022</p>
            <br />
            <span>Durante o meu tempo como técnico de TI na Ideal Informática e Celulares, tive a oportunidade de desempenhar as seguintes atividades:</span>
            <br />
            <br />
            <ul>
              <li> ○ Atualização e restauração de software para dispositivos móveis corrompido com as ferramentas Odin e iTunes;</li>
              <li> ○ Montagem e substituição de componentes de hardware danificados em computadores;</li>
              <li> ○ Substituição de pastas térmicas e limpeza interna dos computadores;</li>
              <li> ○ Instalação de programas e sistemas operacionais, incluindo Windows e Linux;</li>
              <li> ○ Configuração de roteadores, redes e crimpagem de cabos RJ45;</li>
              <li> ○ Instalação e manutenção de impressoras, incluindo a recarga de cartuchos;</li>
              <li> ○ Atendimento direto a clientes;</li>
              <li> ○ Venda de produtos e serviços;</li>
              <li> ○ Controle de estoque e cadastro de produtos.</li>
            </ul>
        </div>
        </div>
      </section>
    )
  }
}